import { render, staticRenderFns } from "./per-le-aziende.vue?vue&type=template&id=65bc361e&scoped=true&"
import script from "./per-le-aziende.vue?vue&type=script&lang=js&"
export * from "./per-le-aziende.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc361e",
  null
  
)

export default component.exports